import React from "react"
import { Icon } from "../icon"
import type { IconName } from "../icon/assets/icon-map"

export type NavigationBadgeType = "paid" | "beta"

const BADGE_ICONS: Record<NavigationBadgeType, IconName> = {
  paid: "diamond",
  beta: "beta-beaker"
}

/**
 * Inline badge icon rendered inside `Navigation.Item`, `Navigation.Group`,
 * and `Navigation.GroupItem` when a `badge` prop is set. Maps the semantic
 * type to the corresponding icon. Internal — used only via the `badge`
 * prop on the three navigation row primitives.
 */
export function NavigationBadge({ type }: { type: NavigationBadgeType }) {
  return (
    <Icon
      name={BADGE_ICONS[type]}
      // eslint-disable-next-line rulesdir/no-deprecated-icon-size
      size="sm"
      className="shrink-0 text-gray-700"
      aria-hidden
    />
  )
}
